import { render, staticRenderFns } from "./EditAjustesOrigen.vue?vue&type=template&id=32bca9f2&scoped=true"
import script from "./EditAjustesOrigen.vue?vue&type=script&lang=js"
export * from "./EditAjustesOrigen.vue?vue&type=script&lang=js"
import style0 from "./EditAjustesOrigen.vue?vue&type=style&index=0&id=32bca9f2&prod&scoped=true&lang=css"
import style1 from "./EditAjustesOrigen.vue?vue&type=style&index=1&id=32bca9f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bca9f2",
  null
  
)

export default component.exports